import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
function SVG({
  className = '',
  size = '24'
}) {
  return ___EmotionJSX("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    className: className,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, ___EmotionJSX("polyline", {
    points: "15 3 21 3 21 9"
  }), ___EmotionJSX("polyline", {
    points: "9 21 3 21 3 15"
  }), ___EmotionJSX("line", {
    x1: "21",
    y1: "3",
    x2: "14",
    y2: "10"
  }), ___EmotionJSX("line", {
    x1: "3",
    y1: "21",
    x2: "10",
    y2: "14"
  }));
}
export default SVG;